import { Link } from "react-router-dom"
import { Button, Typography } from "@mui/material"
import { AutoAwesomeMosaicOutlined } from "@mui/icons-material"

// The button can either be a function or a link, but not both
interface DashboardButtonProps {
  to?: string | never
  onClick?: (() => void) | never
}

export function DashboardButton(props: DashboardButtonProps) {
  const { to, onClick } = props
  if (!to && !onClick) {
    return null
  }
  const isLink = Boolean(to)
  return (
    <Button
      variant="outlined"
      endIcon={<AutoAwesomeMosaicOutlined />}
      className="dashboard-button"
      {...(isLink ? { component: Link, to } : {})}
      onClick={(ev) => {
        ev.stopPropagation()
        onClick?.()
      }}
      tabIndex={-1}
      size="small"
    >
      <Typography className="dashboard-button-label">Dashboard</Typography>
    </Button>
  )
}

export function getDashboardInstrumentUrl(account: string, instrumentType: string, instrumentId: string): string {
  return `/${account}/dashboard?instrumentType=${instrumentType.toLowerCase()}&instrumentId=${instrumentId}`
}
